import {ProvidingListApplication} from '../../../models/api';

export default [
  {
    id: 159,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 159',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 158,
    // isRead: false,
    statusId: 2,
    statusName: 'Не одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 158',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 157,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 157',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 156,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 156',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 155,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 155',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 154,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 154',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 153,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 153',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 152,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 152',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 151,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 151',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 150,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 150',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 149,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 149',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 148,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 148',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 147,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 147',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 146,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 146',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 145,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 145',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 144,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 144',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 143,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 143',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 142,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 142',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 141,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 141',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 140,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 140',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 139,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 139',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 138,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 138',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 137,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 137',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 136,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 136',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 135,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 135',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 134,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 134',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 133,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 133',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 132,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 132',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 131,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 131',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 130,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 130',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 129,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 129',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 128,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 128',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 127,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 127',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 126,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 126',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 125,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 125',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 124,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 124',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 123,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 123',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 122,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 122',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 121,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 121',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 120,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 120',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 119,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 119',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 118,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 118',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 117,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 117',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 116,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 116',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 115,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 115',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 114,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 114',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 113,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 113',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 112,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 112',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 111,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 111',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 110,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 110',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 109,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 109',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 108,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 108',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 107,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 107',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 106,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 106',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 105,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 105',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 104,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 104',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 103,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 103',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 102,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 102',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 101,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 101',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 100,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 100',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 99,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 99',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 17,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 4,
    typeApplicationName: 'Окончание срока действия 17',
    dateTimeFiling: '2020-08-24',
    statusHistory: [
      {
        date: '2020-08-24',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 98,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 98',
    dateTimeFiling: '2020-05-26',
    statusHistory: [
      {
        date: '2020-05-26',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 92,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 92',
    dateTimeFiling: '2020-04-17',
    statusHistory: [
      {
        date: '2020-04-17',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 63,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 2,
    typeApplicationName: 'Выдача в случае хищения 63',
    dateTimeFiling: '2020-04-13',
    statusHistory: [
      {
        date: '2020-04-13',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 47,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 3,
    typeApplicationName: 'Выдача в случае утраты 47',
    dateTimeFiling: '2020-03-31',
    statusHistory: [
      {
        date: '2020-03-31',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
  {
    id: 33,
    // isRead: false,
    statusId: 3,
    statusName: 'Одобрено',
    typeApplicationId: 1,
    typeApplicationName: 'Выдача впервые 33',
    dateTimeFiling: '2020-03-06',
    statusHistory: [
      {
        date: '2020-03-06',
        statusId: 3,
        statusName: 'Одобрено',
        note: undefined,
      },
    ],
  },
] as ProvidingListApplication[];
